export default __webpack_public_path__ + "static/rchand-d6b78dae43f4c5ca182abcce4cc4486f.png";